import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Scrollfunctions from '../Components/Scrollfunctions';

// Import all specific images for Wallcoverings loop
const img1 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Wallcoverings/1.jpg";
const img2 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Wallcoverings/2.jpg";
const img3 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Wallcoverings/3.jpg";
const img4 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Wallcoverings/4.jpg";
const img5 = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Wallcoverings/5.jpg";


// Import all specific images for Artprints loop
const img1artprint = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Artprints/1.jpg";
const img2artprint = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Artprints/2.jpg";
const img3artprint = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Artprints/3.jpg";
const img4artprint = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Artprints/4.jpg";
const img5artprint = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Artprints/5.jpg";


const img1handpainting = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Hand_Paintings/1.jpg"
const img2handpainting = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Hand_Paintings/2.jpg"
const img3handpainting = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Hand_Paintings/3.jpg"
const img4handpainting = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Hand_Paintings/4.jpg"
const img5handpainting = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Hand_Paintings/5.jpg"


const img1customproject = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Customize_Project/1.jpg";
const img2customproject = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Customize_Project/2.jpg";
const img3customproject = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Customize_Project/3.jpg";
const img4customproject = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Customize_Project/4.jpg";
const img5customproject = "https://vizaura.s3.eu-north-1.amazonaws.com/Components/images_loop_Explore_Other_categories/Customize_Project/5.jpg";


// Define the new data array directly in this file as requested
const SecondSlidedatamain = [
  {
    // Changed Img to an array of imported images for the loop
    Img: [img1, img2, img3, img4, img5],
    title: "Wallcoverings",
    desc: "Transform your walls with designs that bring your space to life.",
    link: "/wallcoverings/decorative",
  },
  {
    Img: [img1artprint, img2artprint, img3artprint, img4artprint, img5artprint],
    title: "Art prints",
    desc: "Elevate your space with art prints that reflect your style and story.",
    link: "/artprints",
  },
  {
    Img:  [img1handpainting, img2handpainting, img3handpainting, img4handpainting, img5handpainting],
    title: "Exclusive hand paintings",
    desc: "Own a one of a kind hand painting that's uniquely yours.",
    link: "/exclusivehandpaintings",
  },
  {
    Img: [img1customproject, img2customproject, img3customproject, img4customproject, img5customproject],
    title: "Customise your project",
    desc: "Get custom designed graphics crafted to match your unique space and vision.",
    link: "/customiseyourproject",
  },
];

// ImageLooper component for handling image transitions
// ImageLooper component for handling image transitions
const ImageLooper = ({ images, title, isHovering }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loadedImages, setLoadedImages] = useState([]); // State to track loaded images

  // Effect to preload images
  useEffect(() => {
    const loadImage = (src) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`Failed to load image: ${src}`));
      });
    };

    const loadAllImages = async () => {
      try {
        const imagePromises = images.map(src => loadImage(src));
        await Promise.all(imagePromises);
        setLoadedImages(images); // Set state with original image array once all are loaded
      } catch (error) {
        console.error(error);
        // You can handle errors here, e.g., setting a fallback image
        setLoadedImages(images); // Still set the images even if some fail, for a best-effort render
      }
    };

    loadAllImages();

    // The rest of the interval logic remains the same
    let intervalId;
    if (!isHovering && images.length > 1) {
      intervalId = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 1000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [images, isHovering]);

  return (
    <div className="relative w-full h-full overflow-hidden">
      {loadedImages.map((imageSrc, index) => (
        <img
          key={imageSrc}
          src={imageSrc}
          alt={`${title} - ${index + 1}`}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ease-in-out`}
          style={{
            opacity: index === currentIndex ? 1 : 0,
            transform: `scale(${index === currentIndex ? 1 : 1.05})`,
            zIndex: index === currentIndex ? 1 : 0,
          }}
        />
      ))}
    </div>
  );
};

// New component to render each suggestion card
const SuggestionCard = ({ item }) => {
  const [isHovering, setIsHovering] = useState(false); // State to manage hover for this specific card

  return (
    <Link
      to={item.link}
      onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
      className="block h-full focus:outline-none focus:ring-2 focus:ring-purple-600 focus:ring-offset-2 rounded-xl"
      onMouseEnter={() => setIsHovering(true)} // Set hover state for this card
      onMouseLeave={() => setIsHovering(false)} // Clear hover state for this card
    >
      <div className="flex flex-col h-full bg-white rounded-xl shadow-sm hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
        <div className="relative w-full pt-[100%] rounded-t-xl overflow-hidden">
          <div className="absolute inset-0">
            {/* Conditionally render ImageLooper or a single img tag */}
            {Array.isArray(item.Img) ? (
              <ImageLooper images={item.Img} title={item.title} isHovering={isHovering} />
            ) : (
              <img
                src={item.Img}
                alt={item.title}
                className="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition-transform duration-700"
                onError={(e) => { e.target.onerror = null; e.target.src = 'https://placehold.co/600x600/cccccc/333333?text=Image+Error'; }} // Fallback for single images
              />
            )}
          </div>
        </div>

        <div className="flex-1 p-6">
          <h3 className="text-lg font-semibold text-gray-500 mb-3 truncate">
            {item.title}
          </h3>
          <p className="text-gray-500 text-sm line-clamp-2 leading-relaxed">
            {item.desc}
          </p>
        </div>

        <div className="px-6 pb-4">
          <div className="text-sm text-gray-500 font-medium flex items-center group">
            Learn more
            <svg
              className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-200"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </div>
        </div>
      </div>
    </Link>
  );
};


const TopSuggestions = () => {
  return (
    <div className="bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 pb-4">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h1 className="text-4xl text-gray-900 inline-block relative group">
            <span className="bg-clip-text font-serif text-gray-500">
              Explore Other Categories
            </span>
            <span className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-gray-900 to-gray-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 ease-out" />
          </h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 font-serif">
          {SecondSlidedatamain.map((item, index) => (
            <SuggestionCard key={index} item={item} /> // Render SuggestionCard for each item
          ))}
        </div>
      </div>

      <div className="overflow-hidden">
        <Scrollfunctions />
      </div>
    </div>
  );
};

export default TopSuggestions;
